import { ref, watch, onMounted, inject, getCurrentInstance, onBeforeUnmount } from 'vue';
// injection.collection {
//   key1: [insta, instb]
//   key2: [instc]
// }
export function useInjectionInstanceCollection(injectionName, collectionKey, registerKeyRef) {
    var _a;
    const injection = inject(injectionName, null);
    if (injection === null)
        return;
    const vm = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    watch(registerKeyRef, registerInstance);
    registerInstance(registerKeyRef.value);
    onBeforeUnmount(() => {
        registerInstance(undefined, registerKeyRef.value);
    });
    function registerInstance(key, oldKey) {
        const collection = injection[collectionKey];
        if (oldKey !== undefined)
            removeInstance(collection, oldKey);
        if (key !== undefined)
            addInstance(collection, key);
    }
    function removeInstance(collection, key) {
        if (!collection[key])
            collection[key] = [];
        collection[key].splice(collection[key].findIndex((instance) => instance === vm), 1);
    }
    function addInstance(collection, key) {
        if (!collection[key])
            collection[key] = [];
        if (!~collection[key].findIndex((instance) => instance === vm)) {
            collection[key].push(vm);
        }
    }
}
// injection.collection {
//   key1: [insta.value, instb.value]
//   key2: [instc.value]
// }
export function useInjectionCollection(injectionName, collectionKey, valueRef) {
    const injection = inject(injectionName, null);
    if (injection === null)
        return;
    if (!(collectionKey in injection)) {
        injection[collectionKey] = [];
    }
    injection[collectionKey].push(valueRef.value);
    watch(valueRef, (value, prevValue) => {
        const collectionArray = injection[collectionKey];
        const index = collectionArray.findIndex((collectionValue) => collectionValue === prevValue);
        if (~index)
            collectionArray.splice(index, 1);
        collectionArray.push(value);
    });
    onBeforeUnmount(() => {
        const collectionArray = injection[collectionKey];
        const index = collectionArray.findIndex((collectionValue) => collectionValue === valueRef.value);
        if (~index)
            collectionArray.splice(index, 1);
    });
}
// injection.collection {
//   key1: [insta.$el, instb.$el]
//   key2: [instc.$el]
// }
export function useInjectionElementCollection(injectionName, collectionKey, getElement) {
    const injection = inject(injectionName, null);
    if (injection === null)
        return;
    if (!(collectionKey in injection)) {
        injection[collectionKey] = [];
    }
    onMounted(() => {
        const el = getElement();
        if (!el)
            return;
        injection[collectionKey].push(el);
    });
    onBeforeUnmount(() => {
        const collectionArray = injection[collectionKey];
        const element = getElement();
        const index = collectionArray.findIndex((collectionElement) => collectionElement === element);
        if (~index)
            collectionArray.splice(index, 1);
    });
}
export function useDeferredTrue(valueRef, delay, shouldDelayRef) {
    if (!delay)
        return valueRef;
    const delayedRef = ref(valueRef.value);
    let timerId = null;
    watch(valueRef, (value) => {
        if (timerId !== null)
            window.clearTimeout(timerId);
        if (value === true) {
            if (shouldDelayRef && !shouldDelayRef.value) {
                delayedRef.value = true;
            }
            else {
                timerId = window.setTimeout(() => {
                    delayedRef.value = true;
                }, delay);
            }
        }
        else {
            delayedRef.value = false;
        }
    });
    return delayedRef;
}
export { useAdjustedTo } from './use-adjusted-to';
export { useHoudini } from './use-houdini';
export { useOnResize } from './use-resize';
export { useLockHtmlScroll, lockHtmlScrollRightCompensationRef } from './use-lock-html-scroll';
